/**
 * Formats a byte count as a human-readable file size in French units
 * (o, Ko, Mo, Go), e.g. 1536 → "1.5 Ko".
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 o";
  const units = ["o", "Ko", "Mo", "Go"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / 1024 ** i).toFixed(i > 0 ? 1 : 0)} ${units[i]}`;
}
